module.exports = __webpack_public_path__ + "img/itomanman_comic02.ad8e7002.jpg";